import { AutocompleteData } from '@dotcom/crown-ui';

type AddressSuggestion = {
  city: string;
  entries: number;
  state: string;
  street_line: string;
  zipcode: string;
};

export const transformAddressesToSugest = (suggestions: AddressSuggestion[]): AutocompleteData[] =>
  suggestions.map((address: AddressSuggestion, index) => ({
    label: index + '',
    value: {
      entries: address.entries || 1,
      streetLine: address.street_line || '',
      city: address.city || '',
      state: address.state || '',
      zip: address.zipcode || '',
    },
  }));
